





















import { Vue, Component } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      importId: "demoData/importId"
    })
  },
  components: {
    "progress-bar": () =>
      import("@/components/app/global/fields/progressBar.vue")
  }
})
export default class DemoDataProgress extends Vue {
  public importId!: string | null;
}
